import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: Number, url: String }

  connect() {
    this.timer = setTimeout(() => {
      const frame = document.querySelector("turbo-frame#entry-form")
      if (frame) frame.src = this.urlValue
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
